(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    


  function ensureLegacyAjaxStubs(productFormEl) {
    try {
      const formEl = productFormEl && productFormEl.querySelector ? productFormEl.querySelector('form') : null;
      if (!formEl) return null;

      // .ajax-submit button used by app.js click handler
      let ajaxSubmit = formEl.querySelector('.ajax-submit');
      if (!ajaxSubmit) {
        ajaxSubmit = document.createElement('button');
        ajaxSubmit.type = 'button';
        ajaxSubmit.className = 'ajax-submit';
        ajaxSubmit.style.display = 'none';
        const span = document.createElement('span');
        ajaxSubmit.appendChild(span);
        formEl.appendChild(ajaxSubmit);
      }

      // .add_to_cart button used by app.js to disable/change text
      let addToCart = formEl.querySelector('.add_to_cart');
      if (!addToCart) {
        addToCart = document.createElement('button');
        addToCart.type = 'button';
        addToCart.className = 'add_to_cart';
        addToCart.style.display = 'none';
        addToCart.setAttribute('data-label', (window.PXUTheme && window.PXUTheme.translation && window.PXUTheme.translation.product_add_to_cart) || 'Add to cart');
        const span = document.createElement('span');
        span.textContent = addToCart.getAttribute('data-label');
        addToCart.appendChild(span);
        formEl.appendChild(addToCart);
      }

      return { formEl, ajaxSubmit, addToCart };
    } catch (_) {
      return null;
    }
  }

  document.addEventListener('product-form:cart:navigate', (event) => {
    try {
      const action = (window.PXUTheme && window.PXUTheme.theme_settings && window.PXUTheme.theme_settings.cart_action) || 'ajax';

      if (action === 'ajax') {
        event.preventDefault();
      } else if (action === 'reload_page') {
        event.preventDefault();
        window.location.reload();
      } else if (action === 'redirect_checkout') {
        event.preventDefault();
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        window.location.href = `${root}checkout`;
      }
    } catch (_) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:cart:request', (event) => {
    try {
      const action = (window.PXUTheme && window.PXUTheme.theme_settings && window.PXUTheme.theme_settings.cart_action) || 'ajax';
      if (action !== 'ajax') return;

      event.preventDefault();

      const stubs = ensureLegacyAjaxStubs(event.target);
      if (!stubs || !stubs.ajaxSubmit) return;

      const pf = event.target;
      if (window.jQuery) {
        const $doc = window.jQuery(document);
        const cleanup = () => { $doc.off('.hvAjaxBridge'); };
        const successHandler = function(e, jqXHR, ajaxSettings, data) {
          try {
            if (ajaxSettings && typeof ajaxSettings.url === 'string' && ajaxSettings.url.indexOf('/cart/add.js') !== -1) {
              cleanup();
              let item = data || (jqXHR && (jqXHR.responseJSON));
              if (!item && jqXHR && jqXHR.responseText) {
                try { item = JSON.parse(jqXHR.responseText); } catch (_) {}
              }
              if (pf && typeof pf.resolveCartRequest === 'function') {
                pf.resolveCartRequest(item);
              }
            }
          } catch (err) {
            cleanup();
            if (pf && typeof pf.rejectCartRequest === 'function') {
              pf.rejectCartRequest(err);
            }
          }
        };
        const errorHandler = function(e, jqXHR, ajaxSettings, thrownError) {
          if (ajaxSettings && typeof ajaxSettings.url === 'string' && ajaxSettings.url.indexOf('/cart/add.js') !== -1) {
            cleanup();
            if (pf && typeof pf.rejectCartRequest === 'function') {
              pf.rejectCartRequest(thrownError || jqXHR);
            }
          }
        };
        $doc.on('ajaxSuccess.hvAjaxBridge', successHandler);
        $doc.on('ajaxError.hvAjaxBridge', errorHandler);
      }

      if (window.jQuery) {
        window.jQuery(stubs.ajaxSubmit).trigger('click');
      } else {
        stubs.ajaxSubmit.click();
      }
    } catch (_) {}
  });

  document.addEventListener('product-form:message:success', (e) => {
    try {
      const action = (window.PXUTheme && window.PXUTheme.theme_settings && window.PXUTheme.theme_settings.cart_action) || 'ajax';
      if (action === 'ajax') {
        e.preventDefault();
      }
    } catch (_) {}
  });

  } catch(e) { console.error(e); }
})();
})();
